import {
  Dialog,
  DialogNavigation,
  DialogContent,
} from "../../../../../components/modal/Dialog";
import { UserSettingsUpdateMarketingPreferencesDialogContent } from "./UserSettingsUpdateMarketingPreferencesDialogContent";

export const UserSettingsUpdateMarketingPreferencesDialog = ({
  active,
  onDismiss,
}: {
  active: boolean;
  onDismiss: () => void;
}) => {
  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
        title={"Marketing preferences"}
        description={"Manage your permissions for updates from Sellar"}
      />
      <DialogContent>
        <UserSettingsUpdateMarketingPreferencesDialogContent
          onDismiss={onDismiss}
        />
      </DialogContent>
    </Dialog>
  );
};
